export const CL = {
  bw: {
    HEX: '#fcfcfc',
    RGB: 'rgb(252, 252, 252)',
    RGBa: 'rgba(252, 252, 252, ',
    HSL: 'hsl(1, 1%, 99%)',
    HSla: 'hsla(1, 1%, ',
    r: 252,
    g: 252,
    b: 252,
    h: 1,
    s: 1,
    l: 99
  },
  navy: {
    HEX: '#536bff',
    RGB: 'rgb(83, 107, 255)',
    RGBa: 'rgba(83, 107, 255, ',
    HSL: 'hsl(232, 100%, 66%)',
    HSla: 'hsla(232, 100%, ',
    r: 83,
    g: 107,
    b: 255,
    h: 232,
    s: 100,
    l: 66
  },
  yellow: {
    HEX: '#ffbf51',
    RGB: 'rgb(255, 191, 81)',
    RGBa: 'rgba(255, 191, 81, ',
    HSL: 'hsl(38, 100%, 66%)',
    HSla: 'hsla(38, 100%, ',
    r: 255,
    g: 191,
    b: 81,
    h: 38,
    s: 100,
    l: 66
  },
  lotus: {
    HEX: '#766bff',
    RGB: 'rgb(118, 107, 255)',
    RGBa: 'rgba(118, 106, 255, ',
    HSL: 'hsl(244, 100%, 71%)',
    HSla: 'hsla(244, 100%, ',
    r: 118,
    g: 107,
    b: 255,
    h: 244,
    s: 100,
    l: 71
  },
  pink: {
    HEX: '#ff5193',
    RGB: 'rgb(255, 81, 147)',
    RGBa: 'rgba(255, 81, 147, ',
    HSL: 'hsl(337, 100%, 66%)',
    HSla: 'hsla(337, 100%, ',
    r: 255,
    g: 81,
    b: 147,
    h: 337,
    s: 100,
    l: 66
  },
  scarlet: {
    HEX: '#ff6672',
    RGB: 'rgb(255, 102, 114)',
    RGBa: 'rgba(255, 102, 114, ',
    HSL: 'hsl(355, 100%, 70%)',
    HSla: 'hsla(355, 100%, ',
    r: 255,
    g: 102,
    b: 114,
    h: 355,
    s: 100,
    l: 70
  },
  orange: {
    HEX: '#ff9628',
    RGB: 'rgb(255, 150, 40)',
    RGBa: 'rgba(255, 150, 40, ',
    HSL: 'hsl(31, 100%, 58%)',
    HSla: 'hsla(31, 100%, ',
    r: 255,
    g: 150,
    b: 40,
    h: 31,
    s: 100,
    l: 58
  },
  turquoise: {
    HEX: '#66e5d1',
    RGB: 'rgb(102, 229, 209)',
    RGBa: 'rgba(102, 229, 209, ',
    HSL: 'hsl(171, 71%, 65%)',
    HSla: 'hsla(171, 71%, ',
    r: 102,
    g: 229,
    b: 209,
    h: 171,
    s: 71,
    l: 65
  },
  lime: {
    HEX: '#d0e951',
    RGB: 'rgb(208, 233, 81)',
    RGBa: 'rgba(208, 233, 81, ',
    HSL: 'hsl(70, 78%, 62%)',
    HSla: 'hsla(70, 78%, ',
    r: 208,
    g: 233,
    b: 81,
    h: 70,
    s: 78,
    l: 62
  }
}

export const DT_COLOR = {
    // 0 book
    0: { color: 'turquoise', xl: 0.5, a: 0.9 },
    100: { color: 'turquoise', xl: 0.8, a: 0.9 },
    // 1 thesis
    1: { color: 'lime', xl: 0.5, a: 0.9 },
    101: { color: 'lime', xl: 0.8, a: 0.9 },
    // 5 journal
    5: { color: 'navy', xl: 0.6, a: 0.9 },
    105: { color: 'navy', xl: 0.7, a: 0.9 },
    // 6 conference
    6: { color: 'lotus', xl: 0.5, a: 0.9 },
    106: { color: 'lotus', xl: 0.8, a: 0.9 },
    // 7 news
    7: { color: 'scarlet', xl: 0.5, a: 0.9 },
    107: { color: 'scarlet', xl: 0.8, a: 0.9 },
    // 8 magazine & blog
    8: { color: 'orange', xl: 0.5, a: 0.9 },
    108: { color: 'orange', xl: 0.8, a: 0.9 },

    // 2 government doc
    2: { color: 'pink', xl: 0.5, a: 0.8 },
    102: { color: 'pink', xl: 0.8, a: 0.8 },
    // 3 law
    3: { color: 'pink', xl: 0.5, a: 0.8 },
    103: { color: 'pink', xl: 0.8, a: 0.8 },
    // 4 statistics
    4: { color: 'pink', xl: 0.5, a: 0.8 },
    104: { color: 'pink', xl: 0.8, a: 0.8 },
    // 9 music
    9: { color: 'pink', xl: 0.5, a: 0.8 },
    109: { color: 'pink', xl: 0.8, a: 0.8 },
    //10 film
    10: { color: 'pink', xl: 0.5, a: 0.9 },
    110: { color: 'pink', xl: 0.8, a: 0.9 },
    //901 map
    901: { color: 'pink', xl: 0.5, a: 0.8 },
    //999 etc
    999: { color: 'pink', xl: 0.5, a: 0.8 }
  }
  // light : black 0, original 1, white infinity 
  // opacity : 0 empty, 1: solid
export function coloring(color, light, opacity) {
  // let h = CL[color].h
  // let s = CL[color].s
  let HS = CL[color].HSla

  let o = CL[color].l / 100
  let x = light
  let l = 1 + (o - 1) / (o * x + 1 - o)

  let a = opacity

  l = l * 100
  a = a * 100

  let L = l.toString() + '%, '
  let A = a.toString() + '%)'
    // console.log(H + S + L + A)
  let color_x = HS + L + A


  // // test rgb
  // let r = CL[color].r
  // let g = CL[color].g
  // let b = CL[color].b
  // let R = 'rgba(' + r.toString() + ', '
  // let G = g.toString() + ', '
  // let B = b.toString() + ', '

  // color_x = R + G + B + A

  return color_x
}

export function coloringDT(dt, light, opacity) {
  let color_t = null

  let DT = DT_COLOR[dt]
  let name = DT.color
  let l = DT.xl * light
  let a = DT.a * opacity

  color_t = coloring(name, l, a)

  return color_t
}


// WEBPACK FOOTER //
// ./src/custom/fn_color.js